import { Link as RouterLink } from 'react-router-dom'
import { Link } from '@bosch/react-frok'

import './NotFound.scss'
import { useTranslation } from 'react-i18next'

const NotFound = () => {
    const { t } = useTranslation()
    return (
        <div className="not-found">
            <h1>{t('404:errorNumer')}</h1>
            <h3>{t('404:label')}</h3>
            <p>{t('404:description', { url: window.location.href })}</p>
            <p>
                {t('404:goBack')}
                <Link as={RouterLink} to={'/'} label={t('404:homePage')}></Link>.
            </p>
        </div>
    )
}

export default NotFound
